module.exports = "// A single thread of sms messages\n\nApp.Collections.SMSMessages = Backbone.Collection.extend({\n\n  model: App.Models.SMS\n  \n});\n"